angular.module('app.controllers').controller('ExhibitorsListCtrl', ['$scope', '$rootScope', 'APIExhibitors', 'UI', 'APIRead', 'APIReadTable', 'Table'].append(function(self, root, APIExhibitors, UI, APIRead, APIReadTable, Table) {
  var cookiesName, ref, tableName;
  tableName = 's.l.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  self.customStat(self.id, 'page_overview', "Automation Solutions Overview opened");
  self.exhibitors = Table({
    name: tableName,
    type: "partial",
    resource: APIReadTable,
    params: {
      limit: 12,
      entry_type: 'campaign',
      lang: 'en'
    }
  });
  self.$watch('exhibitors.params', function(newObj, oldObj) {
    return self.page = 1;
  }, true);
  self.page = 1;
  return self.loadMore = function() {
    var params;
    if (self.page >= self.exhibitors.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.exhibitors.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIRead.query(params, function(data) {
      self.more = data;
      self.exhibitors.data.display = self.exhibitors.data.display.concat(self.more);
      return self.moreLoad = false;
    });
  };
}));
